import { Component, ViewChild, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Global } from '../../../shared/global';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const swal = require('sweetalert');

@Component({
  selector: 'app-hoso-danhsachnhanvienedit',
  templateUrl: './danhsachnhanvienedit.component.html',
  styleUrls: ['./danhsachnhanvienedit.component.scss'],
  providers: [ListService, Repository]
})
export class danhsachnhanvieneditComponent implements OnInit {
  @Output() save: EventEmitter<any> = new EventEmitter();
  @ViewChild('modalnv', { static: false }) modalnv: ModalComponent;
  @ViewChild('dtenhanvien', { static: false }) dtenhanvien: any;
  @ViewChild('fileImport', { static: false }) fileImport: ElementRef;

  currentUser: any;
  inputdonvis: any[] = [];
  selectedDonViId: number = null;
  tenDonViHienTai = '';
  datas: any[] = [];
  totalItems = 0;
  currentPage = 1;
  pageSize = 20;
  pages: any;
  totalPages = 0;
  TatCa = false;
  TimKiems: any = {
    DonViId: null, Ma: null, Ten: null, CapDonVi: null,
    StartPage: 1, EndPage: 20, startPage: 1, endPage: 20
  };
  modalTitle = '';
  quyen_sua = true;

  constructor(private _dataService: ListService, public repo: Repository, private http: HttpClient) { }

  ngOnInit(): void { }

  loadDataInit(donViId: number, tenDonVi: string) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.selectedDonViId = donViId;
    this.tenDonViHienTai = tenDonVi || '';
    this.TimKiems.Ma = null;
    this.TimKiems.Ten = null;
    this.TimKiems.CapDonVi = null;
    this.currentPage = 1;
    this.TatCa = false;

    this.repo.postRequest('api/hoso/donvi_user', {}).subscribe(res => {
      if (typeof res === 'string') {
        swal('Lỗi!', res, 'error');
        this.inputdonvis = donViId ? [{ Id: donViId, Ten: tenDonVi, Ma: '' }] : [];
        this.selectedDonViId = donViId;
        this.updateTenDonVi();
        this.Loaddatas();
        return;
      }
      this.inputdonvis = Array.isArray(res) ? res : [];
      const inScope = this.inputdonvis.find((x: any) => Number(x.Id) === Number(donViId));
      if (inScope) {
        this.selectedDonViId = donViId;
      } else if (donViId) {
        this.inputdonvis = [{ Id: donViId, Ten: tenDonVi || ('Đơn vị #' + donViId), Ma: '' }].concat(this.inputdonvis);
        this.selectedDonViId = donViId;
      } else if (this.inputdonvis.length > 0) {
        this.selectedDonViId = this.inputdonvis[0].Id;
      } else {
        this.selectedDonViId = null;
      }
      this.updateTenDonVi();
      this.Loaddatas();
    }, () => {
      this.inputdonvis = donViId ? [{ Id: donViId, Ten: tenDonVi, Ma: '' }] : [];
      this.selectedDonViId = donViId;
      this.Loaddatas();
    });
  }

  updateTenDonVi() {
    const dv = this.inputdonvis.find((x: any) => Number(x.Id) === Number(this.selectedDonViId));
    this.tenDonViHienTai = dv ? dv.Ten : this.tenDonViHienTai;
  }

  onChangeDonVi() {
    this.updateTenDonVi();
    this.currentPage = 1;
    this.TatCa = false;
    this.Loaddatas();
  }

  onKeydownEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) this.search();
  }

  search() {
    this.currentPage = 1;
    this.Loaddatas();
  }

  search1() { this.Loaddatas(); }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    this.Loaddatas();
  }

  TichTatCa() {
    (this.datas || []).forEach((x: any) => { x.Tich = this.TatCa; });
  }

  getSelectedIds(): string {
    return (this.datas || [])
      .filter((x: any) => x.Tich)
      .map((x: any) => x.Id)
      .join(',');
  }

  Loaddatas(): void {
    this.datas = [];
    this.TatCa = false;
    if (!this.selectedDonViId) {
      this.totalItems = 0;
      this.totalPages = 0;
      return;
    }
    const start = (this.currentPage - 1) * this.pageSize + 1;
    const end = this.currentPage * this.pageSize;
    this.TimKiems.DonViId = this.selectedDonViId;
    this.TimKiems.StartPage = start;
    this.TimKiems.EndPage = end;
    this.TimKiems.startPage = start;
    this.TimKiems.endPage = end;
    this.totalItems = 0;

    $('#loading').show();
    this.repo.postRequest('api/hoso/get_list_nhanvien_donvi', this.TimKiems).subscribe(response => {
      $('#loading').hide();
      this.totalPages = 0;
      this.totalItems = 0;
      if (typeof response === 'string') {
        swal('Lỗi!', response, 'error');
        this.datas = [];
        return;
      }
      if (response && response.length > 0) {
        this.totalItems = response[0]['totalRows'] || 0;
        this.totalPages = Math.ceil(this.totalItems / this.pageSize) || 0;
        let startP, endP;
        if (this.totalPages <= 5) { startP = 1; endP = this.totalPages; }
        else if (this.currentPage <= 3) { startP = 1; endP = 5; }
        else if (this.currentPage + 1 >= this.totalPages) { startP = this.totalPages - 4; endP = this.totalPages; }
        else { startP = this.currentPage - 2; endP = this.currentPage + 2; }
        const resultArray: Array<any> = [];
        for (let i = startP; i <= endP; i++) resultArray.push({ Id: i });
        this.pages = resultArray;
      }
      this.datas = (Array.isArray(response) ? response : []).map((x: any) => {
        x.Tich = false;
        return x;
      });
    }, () => { $('#loading').hide(); });
  }

  adddata() {
    if (!this.selectedDonViId) {
      swal('Cảnh báo!', 'Chưa chọn đơn vị.', 'warning');
      return;
    }
    this.modalTitle = 'Thêm nhân viên';
    this.dtenhanvien.loadDataInit(null, this.selectedDonViId, this.tenDonViHienTai);
    this.modalnv.open();
  }

  editdata(row: any) {
    if (row && (row.IsLocked == 1 || row.IsLocked === true)) {
      swal('Cảnh báo!', 'Nhân viên đang bị khóa. Mở khóa trước khi sửa.', 'warning');
      return;
    }
    this.modalTitle = 'Cập nhật nhân viên';
    this.dtenhanvien.loadDataInit(row.Id, this.selectedDonViId, this.tenDonViHienTai);
    this.modalnv.open();
  }

  saveModalNv(data: any) {
    this.modalnv.dismiss();
    if (data != null) this.Loaddatas();
  }

  deletedata(id: any) {
    swal({
      title: 'Bạn muốn xóa nhân viên?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: 'warning',
      buttons: {
        cancel: { text: 'Hủy bỏ', value: false, visible: true, className: 'bg-danger' },
        confirm: { text: 'Đồng ý', value: true, visible: true, className: 'bg-success', closeModal: true }
      }
    }).then((willDelete: boolean) => {
      if (willDelete) {
        $('#loading').show();
        this.repo.postRequest('api/hoso/xoa_nhanvien', { Id: String(id) }).subscribe(data => {
          $('#loading').hide();
          if (data === 'OK') {
            swal('Deleted!', 'Đã xóa nhân viên.', 'success');
            this.Loaddatas();
          } else {
            swal('Cảnh báo!', data, 'warning');
          }
        }, () => { $('#loading').hide(); });
      }
    });
  }

  khoanhanvien(loai: number) {
    const ids = this.getSelectedIds();
    if (!ids) {
      swal('Cảnh báo!', loai === 1 ? 'Chưa chọn nhân viên để khóa.' : 'Chưa chọn nhân viên để mở khóa.', 'warning');
      return;
    }
    const title = loai === 1 ? 'Khóa nhân viên đã chọn?' : 'Mở khóa nhân viên đã chọn?';
    swal({
      title: title,
      text: '',
      icon: 'warning',
      buttons: {
        cancel: { text: 'Hủy bỏ', value: false, visible: true },
        confirm: { text: 'Đồng ý', value: true, visible: true, className: 'bg-success', closeModal: true }
      }
    }).then((ok: boolean) => {
      if (!ok) return;
      $('#loading').show();
      this.repo.postRequest('api/hoso/khoa_nhanvien', { Chuoi: ids, Status: loai }).subscribe(data => {
        $('#loading').hide();
        if (data === 'OK') {
          swal('Thành công!', loai === 1 ? 'Đã khóa nhân viên.' : 'Đã mở khóa nhân viên.', 'success');
          this.Loaddatas();
        } else {
          swal('Cảnh báo!', data, 'warning');
        }
      }, () => { $('#loading').hide(); });
    });
  }

  exportExcel() {
    if (!this.selectedDonViId) {
      swal('Cảnh báo!', 'Chưa chọn đơn vị.', 'warning');
      return;
    }
    $('#loading').show();
    const payload = {
      DonViId: this.selectedDonViId,
      Ma: this.TimKiems.Ma,
      Ten: this.TimKiems.Ten,
      CapDonVi: this.TimKiems.CapDonVi,
      StartPage: 1,
      EndPage: 100000
    };
    this.repo.postRequest('api/hoso/get_list_nhanvien_donvi', payload).subscribe(response => {
      $('#loading').hide();
      if (typeof response === 'string') {
        swal('Lỗi!', response, 'error');
        return;
      }
      const rows = Array.isArray(response) ? response : [];
      const exportRows = rows.map((u: any, i: number) => ({
        STT: u.RowNum || (i + 1),
        MaNV: u.MaNV || '',
        HoVaTen: u.HoVaTen || '',
        GioiTinh: this.gioiTinhText(u.GioiTinh),
        NgaySinh: u.NgaySinh ? new Date(u.NgaySinh) : '',
        SoCMND: u.SoCMND || '',
        TenChucVu: u.TenChucVu || '',
        PhongBan: u.PhongBan || '',
        DienThoai: u.DienThoaiDiDong || '',
        Email: u.Email || '',
        TrangThai: (u.IsLocked == 1 || u.IsLocked === true) ? 'Không hoạt động' : 'Hoạt động'
      }));
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportRows);
      const workbook: XLSX.WorkBook = { Sheets: { 'NhanVien': worksheet }, SheetNames: ['NhanVien'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const data: Blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const ten = (this.tenDonViHienTai || 'DonVi').replace(/[\\/:*?"<>|]/g, '_');
      FileSaver.saveAs(data, 'DS_NhanVien_' + ten + '.xlsx');
    }, () => { $('#loading').hide(); });
  }

  downloadMau() {
    const token = this.currentUser && this.currentUser.access_token ? this.currentUser.access_token : '';
    const headers = new HttpHeaders().set('Authorization', 'Bearer ' + token);
    $('#loading').show();
    this.http.post(Global.App_url + 'api/hoso/mau_import_nhanvien', {}, {
      headers: headers,
      responseType: 'blob'
    }).subscribe(blob => {
      $('#loading').hide();
      FileSaver.saveAs(blob, 'Mau_Import_NhanVien_DonVi.xlsx');
    }, () => {
      $('#loading').hide();
      swal('Lỗi!', 'Không tải được mẫu import.', 'error');
    });
  }

  clickImport() {
    if (!this.selectedDonViId) {
      swal('Cảnh báo!', 'Chưa chọn đơn vị.', 'warning');
      return;
    }
    if (this.fileImport && this.fileImport.nativeElement) {
      this.fileImport.nativeElement.value = null;
      this.fileImport.nativeElement.click();
    }
  }

  onImportFile(event: any) {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    const file: File = files[0];
    const formData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('donviid', String(this.selectedDonViId));
    formData.append('user', this.currentUser && this.currentUser.user_name ? this.currentUser.user_name : '');
    const headers = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + (this.currentUser && this.currentUser.access_token ? this.currentUser.access_token : ''));
    $('#loading').show();
    this.http.post(Global.App_url + 'api/hoso/import_nhanvien_donvi', formData, {
      headers: headers,
      responseType: 'text'
    }).subscribe((res: string) => {
      $('#loading').hide();
      event.target.value = null;
      let msg = (res || '').replace(/^"|"$/g, '');
      if (msg.startsWith('OK')) {
        swal('Thành công!', msg.replace(/^OK\|?/, '') || 'Import hoàn tất.', 'success');
        this.Loaddatas();
      } else {
        swal('Kết quả import', msg || 'Có lỗi khi import.', 'warning');
        this.Loaddatas();
      }
    }, () => {
      $('#loading').hide();
      swal('Lỗi!', 'Import thất bại.', 'error');
    });
  }

  closeModal() {
    this.save.emit(null);
  }

  gioiTinhText(gt: any) {
    if (gt === 1 || gt === '1' || gt === true) return 'Nam';
    if (gt === 0 || gt === '0' || gt === false) return 'Nữ';
    return '';
  }
}
